import { IEntity, IPagedSearchParams } from '@pf/shared-common';
import {
    PurchaseOrderLineSearchRequestParams,
    PurchaseOrderLineViewModelCreateBody,
    PurchaseOrderLineViewModelRead,
} from '@control-tower/platform-orders';
import {
    Currency,
    ItemFragment,
    PurchaseOrderStatus,
    ResourceAuth,
} from '@control-tower/platform-wms';
import { CustomFieldDto } from '@pf/shared/util-platform';

export type PurchaseOrderLineRead = PurchaseOrderLineViewModelRead & IEntity;
export type PurchaseOrderLineCreate = PurchaseOrderLineViewModelCreateBody;
export type PurchaseOrderLineSearchParams =
    PurchaseOrderLineSearchRequestParams & IPagedSearchParams;

export class PurchaseOrderLineDto implements IEntity {
    constructor(data: Partial<PurchaseOrderLineDto>) {
        Object.assign(this, data);
    }
    id!: string;
    isDeleted?: boolean;
    createdDate?: string;
    modifiedDate?: string;
    itemId!: string;
    lineNumber!: number;
    quantity!: number;
    itemPrice?: Currency;
    totalPrice?: Currency;
    notes?: string | null;
    status?: PurchaseOrderStatus;
    resourceAuth?: ResourceAuth;
    item?: ItemFragment;
    customFields?: Array<CustomFieldDto> | null;
    requisitionLineId?: string | null;
    requisitionId?: string | null;
    purchaseOrderHeaderId?: string;
}
